import React, {useRef, useState} from 'react'
import axios from '../../../../../services/axios'
import getProduct from '@/services/ProductService/getProduct';
import DynamicForm from '../../../../../components/DynamicForm'
import {Button} from '../../../../../components/UiElements'
import cloneFormView from './ClonePrpfileBySKUForm'
import productProfileLoadData from './dataMapping/loadProductProfile'
import shapeProfileLoadData from './dataMapping/loadShapeProfile'
import sectionsLoadData from './dataMapping/loadSections'
//import downloadFile from "@/services/downloadFile";


const OpenCloneProductBySKUForm = ({change}) => {
	const cloneFormRef = useRef(null)
	
	return (
		<DynamicForm
			ref={cloneFormRef}
			items={(defaultValues, value) => [
				{
					name: 'clone_profile',
					labelClassName: 'hidden',
					type: 'PopUp',
					module: CloneProductProfileBySKU,
					view: ({show}) => (
						<Button
							type={'alt'}
							className={' !flex-row flex'}
							onClick={() => {
								show()
							}}
						>
							<div className={'flex flex-row gap-md'}>
								<span className={'font-icon-solid'}></span>
								Clone from other products By SKU
							</div>
						</Button>
					),
					title: 'Clone Profile By SKU',
					innerClassName: 'w-[550px]',
					change: change,
					
				},
			]}
			defaultValues={{}}
			size={'md'}
		/>
	)
}
export {OpenCloneProductBySKUForm}

const CloneProductProfileBySKU = ({data, item, close, valid}) => {
	const formRef = useRef(null)
	const [loading, setLoading] = useState(false)
	
	
	const saveData = async () => {
		const formData = await formRef?.current?.getData()
		
		console.log(formData, data, "data--------<", valid, item, data.product_SKU)
		
		
		const product = await getProduct(formData.product_SKU)
		console.log("product", product)
		
		if (formData && product.product_profile_id) {
			
			setLoading(true)
			
			
			await axios(`/productProfiles/${product.product_profile_id}`, 'GET')
			.then(async (response) => {
				
				
				const currentData = await window.prfileSetForm.current.getData()
				
				/*await item.change(productProfileLoadData(response), 'product_profile')
				await item.change(shapeProfileLoadData(response.shape_profile), 'shape_profile')
				await item.change(response.pricing?.id, 'pricing')
				//await item.change(sectionsLoadData(response.shape_profile.sections), "sections", null, null, null)
				await item.change(sectionsLoadData(response.shape_profile.sections), 'sections', {
					id: formData.profile,
					list: sectionsLoadData(response.shape_profile.sections),
				}, true, true)
				await item.change("memet", "divider")
				await item.change("", 'sectionsValidations')*/
				
				//await item.valid
				
				window.prfileSetForm.current.setData({
					...currentData,
					sections: []
				})
				const innerInitialData = {
					...currentData,
					product_profile: productProfileLoadData(response),
					shape_profile: shapeProfileLoadData(response.shape_profile),
					sections: sectionsLoadData(response.shape_profile.sections),
					
					pricing: response.pricing?.id,
					sectionsValidations: [],
				}
				
				console.log("innerInitialData", innerInitialData, currentData)
				
				window.prfileSetForm.current.setData(innerInitialData)
				close()
			})
			
			
			.catch((error) => {
				console.log(error)
				setLoading(false)
			})
			
			//submit(data)
		}
	}
	return (
		<div className={'py-xl px-xl flex flex-col gap-md'}>
			<DynamicForm ref={formRef} items={cloneFormView} size={'md'}/>
			
			<div className={'pt-md flex flex-row gap-sm justify-end'}>
				<Button
					className={' !flex-row flex'}
					type={'alt'}
					onClick={() => {
						close()
					}}
				>
					<div className={'flex flex-row gap-md'}> Cancel</div>
				</Button>
				<Button
					className={' !flex-row flex'}
					disabled={loading}
					onClick={() => {
						saveData()
					}}
				>
					<div className={'flex flex-row gap-md'}> Clone Profile By SKU</div>
				</Button>
			</div>
		</div>
	)
}
